import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        loginWithToken(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/account");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-white" />
      <p className="text-muted-foreground text-sm tracking-luxe uppercase">Signing you in</p>
    </div>
  );
}
